export default __webpack_public_path__ + "static/media/checkbox_disabled.b49af301.svg";